import React from 'react'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import { t } from 'i18next'
import { isVideo } from '../utils/customerDisplay.utils'

function CustomerDisplayPreviewModal({ item, onClose }) {
  return (
    <Dialog
      open={!!item}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-testid="modal-customer-display-preview">
      <DialogTitle>{t('CUSTOMER_DISPLAY_SETTINGS.LIST.PREVIEW')}</DialogTitle>

      <DialogContent className="customer-display-preview">
        {item && isVideo(item.MediaType) ? (
          <video
            src={item.FileUrl}
            controls
            autoPlay
            className="customer-display-preview-media"
          />
        ) : (
          <img
            src={item?.FileUrl}
            alt={item?.Name || ''}
            className="customer-display-preview-media"
          />
        )}
      </DialogContent>
    </Dialog>
  )
}

export default CustomerDisplayPreviewModal
